<div class="d-flex align-items-center justify-content-start gap-2 px-3 py-2 rounded-2 bg-warning-subtle">
    <div [innerHTML]="(noticeContent | async) ?? '' | safeHtml"></div>
</div>